import { ScienceProject } from '../types/interfaces'

export default [
  {
    name: 'Physics and Technology of Glassy Materials',
    description:
      'Glassy materials based on silicon and phosphorus oxides form the foundation of modern optoelectronics. Their unique, amorphous structure allows for extensive modification of physicochemical properties. As part of my scientific activity, I synthesize innovative silicate-phosphate glasses and comprehensively study their electrical and optical properties, which is crucial for designing a new generation of optical fibers and sensors.',
    time: '2025+',
  },
  {
    name: 'Ionic Conductivity in Glass-Ceramic Composites',
    description:
      'Glass-ceramic composites exhibiting high ionic conductivity (Li+, Na+, K+, O2-) are a key element of the revolution in energy storage and conversion. They represent a safe alternative to liquid components in next-generation solid-state batteries and fuel cells. My research focuses on optimizing ion transport in these structures by analyzing their microstructure and performing impedance measurements.',
    time: '2025+',
  },
  {
    name: 'Modeling of Ionic Processes',
    description:
      'The application of artificial intelligence is revolutionizing modern materials engineering. Using neural networks and machine learning (ML potentials) allows simulating molecular dynamics and ion transport in glassy materials with quantum accuracy at minimal computational cost. The project involves implementing machine learning algorithms to predict the structural and diffusive properties of glasses.',
    time: '2026+',
  },
  {
    name: 'Accelerators and Nuclear Equipment',
    description:
      'Accelerators are devices used to accelerate particles and emit radiation. They find many applications in industry and scientific research, where they are used, among others, for ion implantation or detecting defects in materials. They are also used in cancer radiotherapy. The construction of nuclear equipment involves both the use of industrial electronics and learning techniques such as ion pumps, vacuum furnaces, and hydraulic cooling systems. During my internship, I learned about the construction and capabilities of accelerators and created software to control them.',
    time: '2025',
    label: {
      text: 'Internship / Practice',
      color: '#00647D',
    },
  },
  {
    name: 'Superionic Conductors',
    description:
      'Superionic conductors are materials that exhibit high ionic conductivity, making them promising for applications in batteries and fuel cells. During a summer mini-internship at the CEZAMAT Center for Advanced Materials and Technologies, we produced samples of such materials and then studied their properties using techniques such as X-ray diffraction (XRD).',
    time: 'Summer 2024',
    label: {
      text: 'Summer project',
      color: '',
    },
  },
  {
    name: 'Bismuth Glass',
    description:
      'During a summer mini-internship at the Faculty of Physics of the Warsaw University of Technology, we dealt with the synthesis of bismuth glass and learning about the properties of materials with crystalline and amorphous structures. Then we examined its electrical, thermal, and structural properties, with particular emphasis on phase transitions, which this material undergoes due to temperature, e.g., crystallization.',
    time: 'Summer 2024',
    label: {
      text: 'Summer project',
      color: '',
    },
  },
] as ScienceProject[]
